import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import api from "./Axios/api";
import { Eye } from "lucide-react";
import Loader from "../components/common/Loader";
const ReturnList = () => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const getData = async () => {
    try {
      setIsLoading(true);
      const res = await api.get("/purchase/return-indent-item-list");
      setData(res.data);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  const columns = useMemo(
    () => [
      {
        accessorKey: "indent_date",
        header: "Indent Date",
        size: 150,
        Cell: ({ cell }) =>
          new Intl.DateTimeFormat("en-GB").format(new Date(cell.getValue())),
      },
      {
        accessorKey: "indent_number",
        header: "Indent Number",
        size: 150,
      },
      {
        accessorKey: "indent_branch_name",
        header: "Branch Name",
        size: 200,
        Cell: ({ cell }) => (
          <div className="max-h-10 overflow-y-auto">
            {cell.getValue()?.split(" ")[1]}
          </div>
        ),
      },
      {
        accessorKey: "items",
        header: "Item Titles",
        size: 300,
        Cell: ({ cell }) => (
          <div className="max-h-10 overflow-y-auto">
            {cell.getValue()?.map((item) => (
              <div key={item._id}>{item.item_title}</div>
            ))}
          </div>
        ),
      },
      {
        accessorKey: "indent_remark",
        header: "Remark",
        size: 200,
      },
      {
        accessorKey: "indent_by_name",
        header: "Indent By",
        size: 150,
      },
      {
        accessorKey: "_id",
        header: "Action",
        size: 200,
        Cell: ({ cell }) => (
          <Link to={`/details/${cell.getValue()}`} state={{ return: "true" }}>
            <button>
              <Eye size={20} />
            </button>
          </Link>
        ),
      },
      {
        accessorKey: "indent_status",
        header: "Status",
        size: 150,
      },
    ],
    [],
  );

  const table = useMaterialReactTable({
    columns,
    data,
  });

  return (
    <div className="flex-1 px-5 w-full">
      <div className="h-10 px-2 flex justify-between items-center text-violet-500 font-bold rounded-md bg-[#fdfdfd] shadow my-2">
        <div className="text-lg">Return items</div>
      </div>

      <div className="w-full min-h-[500px] rounded-md shadow bg-[#fdfdfd]">
        {isLoading ? <Loader /> : <MaterialReactTable table={table} />}
      </div>
    </div>
  );
};

export default ReturnList;
